<template>
  <b-card>
    <h3 class="font-semibold text-[#333] text-[20px] pb-[16px] mb-0">
      Data Anggota
    </h3>
    <TabComponent
      :tabs="CREATOR_DATA_TABS"
      :count="userCounts"
      @tab-change="handleTabChange"
    />
    <filter-component
      ref="filterComponent"
      @filter-change="handleFilterChange"
    />
    <table-component
      ref="tableComponent"
      :filter="filter"
      @set-user-count="setUserCount"
    />
  </b-card>
</template>

<script>
import { CREATOR_DATA_TABS } from '../config'
import FilterComponent from './Filter.vue'
import TableComponent from './Table.vue'
import TabComponent from '../Tab.vue'

export default {
  components: {
    FilterComponent,
    TableComponent,
    TabComponent,
  },
  data() {
    return {
      userCounts: {
        registered: 0, mcn: 0, tap: 0, suspend: 0, blacklisted: 0,
      },
      filter: {
        tab: 'semua',
        keyword: '',
        category: [],
      },
      CREATOR_DATA_TABS,
    }
  },
  mounted() {
    this.$nextTick(() => this.fetchFromCurrentFilter())
  },
  methods: {
    /**
     * Muat data tabel sesuai filter yang tersimpan di URL / komponen filter
     */
    fetchFromCurrentFilter() {
      const { filterComponent, tableComponent } = this.$refs
      if (!filterComponent || !tableComponent) return
      filterComponent.emitFilterData()
    },
    /**
     * Reset filter saat tab berubah
     * @param {string} tab
     */
    handleTabChange(tab) {
      this.$set(this.filter, 'tab', tab)
      if (this.$refs.filterComponent) this.$refs.filterComponent.resetAll()
    },
    /**
     * Refresh data tabel dengan filter baru
     * @param {Object} filter
     */
    handleFilterChange(filter) {
      this.$refs.tableComponent.refreshData({
        ...filter,
        status: this.filter.tab,
      })
    },
    /**
     * Perbarui counter jumlah kreator per tab
     * @param {Record<string, number>} count
     */
    setUserCount(count) {
      this.userCounts = { ...this.userCounts, ...count }
    },
  },
}
</script>
